import { useEffect, useRef, useCallback } from 'react'

export function useAppVisibility(params: {
	onForeground?: () => void
	onBackground?: () => void
	enabled?: boolean
}) {
	const { onForeground, onBackground, enabled = true } = params
	const wasVisibleRef = useRef<boolean>(document.visibilityState === 'visible')

	const handleVisibilityChange = useCallback(() => {
		const isVisible = document.visibilityState === 'visible'
		const wasVisible = wasVisibleRef.current

		if (isVisible && !wasVisible) {
			onForeground?.()
		} else if (!isVisible && wasVisible) {
			onBackground?.()
		}

		wasVisibleRef.current = isVisible
	}, [onForeground, onBackground])

	useEffect(() => {
		if (!enabled)
			return

		wasVisibleRef.current = document.visibilityState === 'visible'

		document.addEventListener('visibilitychange', handleVisibilityChange)

		return () => {
			document.removeEventListener('visibilitychange', handleVisibilityChange)
		}
	}, [enabled, handleVisibilityChange])
}
